import { render } from "./validate.vue?vue&type=template&id=2a311c5c&scoped=true"
import script from "./validate.vue?vue&type=script&lang=js"
export * from "./validate.vue?vue&type=script&lang=js"

import "./validate.vue?vue&type=style&index=0&id=2a311c5c&scoped=true&lang=css"
import "./validate.vue?vue&type=style&index=1&id=2a311c5c&lang=css"
script.render = render
script.__scopeId = "data-v-2a311c5c"

export default script